// STAGING-LAUNCH-READINESS-002-R2-R2 — shared bounded-fetch helper.
// Root cause of the "infinite spinner" / "back hangs" reports: every network
// call in the Store V2 client (payret restore, NovaPay status, cabinet orders)
// used a bare `fetch()` with no timeout. When the Worker/API was slow or the
// request stalled, the awaiting promise never settled, so screens gated on it
// (payret bootstrap, order success, "Мої замовлення") spun forever with no
// escape hatch. Every such call must go through this helper instead.

export const DEFAULT_FETCH_TIMEOUT_MS = 8000;

export class FetchTimeoutError extends Error {
  constructor(message = "fetch_timeout") {
    super(message);
    this.name = "FetchTimeoutError";
  }
}

/** fetch() with a hard AbortController timeout; rejects with FetchTimeoutError on expiry. */
export async function fetchWithTimeout(
  input: string,
  init: RequestInit = {},
  timeoutMs: number = DEFAULT_FETCH_TIMEOUT_MS,
): Promise<Response> {
  const controller = new AbortController();
  const timer = window.setTimeout(() => controller.abort(), timeoutMs);
  try {
    return await fetch(input, { ...init, signal: controller.signal });
  } catch (err) {
    if (err instanceof DOMException && err.name === "AbortError") {
      throw new FetchTimeoutError();
    }
    throw err;
  } finally {
    window.clearTimeout(timer);
  }
}

export function isFetchTimeout(err: unknown): boolean {
  return err instanceof FetchTimeoutError || (err instanceof DOMException && err.name === "AbortError");
}
